import { Fragment, useState } from "react";
import { AlertBox, SNETButton, SNETTextfield } from "shared/dist/components";
import { getAddress, initSDK } from "shared/dist/utils/snetSdk";

const MMAddress = ({ address, setAddress }) => {
    const [connectingError, setConnectingError] = useState();

    const handleConnetMM = async () => {
        try {
            const sdk = await initSDK();
            const address = await getAddress(sdk);
            setAddress(address);
        } catch (error) {
            setConnectingError(error);
        }
    };

    if (!!address) {
        return (
            <Fragment>
                <SNETTextfield
                    variant="outlined"
                    name="ownerAddress"
                    value={address}
                    label="Metamask Address"
                />
                <SNETButton
                    color="primary"
                    variant="contained"
                    children="capture from metamask"
                    onClick={handleConnetMM}
                    error={connectingError}
                />
            </Fragment>
        );
    }

    return (
        <Fragment>
            <AlertBox
                message="Please install or log in to Metamask to proceed further"
                type="warning"
            />
            <SNETButton
                color="primary"
                variant="contained"
                children="connect metamask"
                onClick={handleConnetMM}
            />
        </Fragment>
    );
};

export default MMAddress;
